var React = require('react');

function BottomBanner (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-12.228 9.0714)"},React.createElement("path",{"d":"m210-9.0714c0 13.817-30.755 13.089-57.807 13.089-56.156 0-31.293 43.498-101.13 43.498-41.975 0-38.78 6.2601-38.78 6.2601h197.72z","fill":"#3290ff","strokeWidth":"0"})));
}

BottomBanner.defaultProps = {"width":"197.77mm","height":"62.848mm","version":"1.1","viewBox":"0 0 197.77 62.848"};

module.exports = BottomBanner;

BottomBanner.default = BottomBanner;
